<template>
    <div class="container">

            <ProfileTitle>
                <template v-slot:header>
                    <h1 class="main__title wow fadeInDown" data-wow-duration="1.5s">anthony salazar</h1>
                    <ul class="main__breadcrumbs wow zoomIn" data-wow-duration="1.5s">
                        <li><a href="">Artists</a></li>
                        <li>Anthony Salazar</li>
                    </ul>
                </template>
            </ProfileTitle>

            <div class="profile">
                <TabContainer/>
            </div>
    </div>


</template>

<script>
import TabContainer from "./TabContainer.vue";
import ProfileTitle from "./ProfileTitle.vue";

export default {
    name: 'Profile',
    components: {ProfileTitle, TabContainer},
}

</script>



<style scoped>

</style>
